/* eslint no-param-reassign: "off", no-console: "off" */
import Vuex from 'vuex';

const subscriptions2Store = new Vuex.Store({
  state: {
    subscriptions: [],
    subscriptionsTotal: 0,
    subscriptionsLoading: false,
    subscriptionsLoadingError: null,
    subscription: null,
    subscriptionLoading: false,
    subscriptionLoadingError: null,
    subscriptionUsageMonthly: [],
    subscriptionUsageDaily: []
  },
  mutations: {
    fetchSubscriptions(state, payload) {
      state.subscriptions = payload.items;
      state.subscriptionsTotal = payload.count;
    },
    fetchSubscription(state, payload) {
      state.subscription = payload;
    },
    fetchSubscriptionUsageMonthly(state, payload) {
      state.subscriptionUsageMonthly = payload;
    },
    fetchSubscriptionUsageDaily(state, payload) {
      state.subscriptionUsageDaily = payload;
    }
  },
  actions: {
    async fetchSubscriptions({ state, commit }, payload) {
      try {
        state.subscriptionsLoading = true;
        const res = await fetch(`/v3/subscriptions?skip=${payload.skip}&take=${payload.take}&sortField=${payload.sortField || ''}&sortDirection=${payload.sortDirection || ''}&query=${payload.query || ''}&fields=${payload.fields || ''}&filters=${payload.filters}`);
        if (!res.ok) throw new Error(await res.text());
        const data = await res.json();
        commit('fetchSubscriptions', data);
        return data;
      } catch (ex) {
        state.subscriptionsLoading = ex;
        return { isError: true, ex };
      } finally {
        state.subscriptionsLoading = false;
      }
    },
    async fetchSubscription({ state, commit }, payload) {
      if (!payload) return null;
      try {
        state.subscriptionLoading = true;
        const res = await fetch(`/v3/subscriptions/${payload.id}`);
        if (!res.ok) throw new Error(await res.text());
        const data = await res.json();
        commit('fetchSubscription', data);
        return data;
      } catch (ex) {
        state.subscriptionLoading = ex;
        return { isError: true, ex }
      } finally {
        state.subscriptionLoading = false;
      }
    },
    async fetchSubscriptionUsageMonthly({ state, commit }) {
      try {
        const res = await fetch(`/v3/subscriptions/${state.subscription.id}/usage?groupBy=monthly`);
        if (!res.ok) throw new Error(await res.text());
        const data = await res.json();
        commit('fetchSubscriptionUsageMonthly', data);
        return data;
      } catch (ex) {
        return { isError: true, ex }
      }
    },
    async fetchSubscriptionUsageDaily({ state, commit }) {
      try {
        const res = await fetch(`/v3/subscriptions/${state.subscription.id}/usage?groupBy=daily`);
        if (!res.ok) throw new Error(await res.text());
        const data = await res.json();
        commit('fetchSubscriptionUsageDaily', data);
        return data;
      } catch (ex) {
        return { isError: true, ex }
      }
    },
    async fetchSubscriptionsByIds({ state }, payload) {
      try {
        state.subscriptionsLoading = true;
        const res = await fetch('/v3/subscriptions', {
          body: JSON.stringify(payload),
          method: 'POST',
          headers: new Headers({ 'Content-Type': 'application/json' })
        });
        if (!res.ok) throw new Error(await res.text());
        const data = await res.json();
        return data;
      } catch (ex) {
        state.subscriptionsLoading = ex;
        return { isError: true, ex };
      } finally {
        state.subscriptionsLoading = false;
      }
    }
  },
  getters: {

  }
});

export default subscriptions2Store;
export const useSubscriptions2Store = () => subscriptions2Store;
